// web/src/theme.ts
import { createTheme } from "@mui/material/styles";

// Snackd Brand Colors
const PRIMARY = "#032736";        // Dark teal - logo, buttons, dark highlights
const PRIMARY_HOVER = "#688E26";  // Olive green - hover states
const SECONDARY = "#688E26";      // Olive green - header/footer
// ACCENT: "#F78764" - Coral - bright accents (use sparingly)
const BG = "#FAF5EA";             // Cream - page background
const TEXT = "#071108";           // Almost black - body text

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: PRIMARY,
      dark: PRIMARY_HOVER,
      contrastText: "#ffffff",
    },
    secondary: {
      main: SECONDARY,
      contrastText: "#ffffff",
    },
    background: {
      default: BG,
      paper: "#ffffff",
    },
    text: {
      primary: TEXT,
      secondary: "#555555",
    },
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    // Headings use a different weight for emphasis
    h1: { fontWeight: 700, color: PRIMARY },
    h2: { fontWeight: 700, color: PRIMARY },
    h3: { fontWeight: 600, color: PRIMARY },
    h4: { fontWeight: 600, color: PRIMARY },
    h5: { fontWeight: 600, color: PRIMARY },
    h6: { fontWeight: 600, color: PRIMARY },
    allVariants: {
      color: TEXT,
    },
  },
  components: {
    // 1) Force <body> background via CssBaseline
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: BG,
        },
      },
    },

    // 2) Brand every <Button variant="contained" color="primary">
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: PRIMARY,
          "&:hover": {
            backgroundColor: PRIMARY_HOVER,
          },
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: SECONDARY,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: SECONDARY,
            borderWidth: 2,
          },
        },
      },
    },
  },
});

export default theme;